import { IDENTITY_PROVIDER, type IdentityProvider } from "../loginRum";

const ACTIVE_SSO_PROVIDER_KEY = "active_sso_provider";

export const SSO_PROVIDER = {
  RIPPLING: "rippling",
  OKTA: "okta",
} as const;

export type SsoProvider = (typeof SSO_PROVIDER)[keyof typeof SSO_PROVIDER];

export function setActiveSsoProvider(provider: SsoProvider): void {
  localStorage.setItem(ACTIVE_SSO_PROVIDER_KEY, provider);
}

export function getActiveSsoProvider(): SsoProvider {
  const value = localStorage.getItem(ACTIVE_SSO_PROVIDER_KEY);
  return value === SSO_PROVIDER.OKTA ? SSO_PROVIDER.OKTA : SSO_PROVIDER.RIPPLING;
}

export function getIdentityProviderForSso(provider: SsoProvider): IdentityProvider {
  return provider === SSO_PROVIDER.OKTA
    ? IDENTITY_PROVIDER.OKTA_SSO
    : IDENTITY_PROVIDER.RIPPLING_SSO;
}

export function getSsoProviderDisplayName(provider: SsoProvider): string {
  return provider === SSO_PROVIDER.OKTA ? "Okta" : "Rippling";
}
